/**
 * JSON-RPC Client Exception class
 * 
 * @param String code
 * @param String message
 */

export class ApiExplorerClientException {

    constructor (code, message) {
        this.code = code;
        this.message = message;
    }

	/**
	 * Magic method. Convert object to string.
	 * 
	 * @return String
	 */
    toString() {
        return '[' + this.code + '] ' + this.message;
    }
    
}
